/* eslint-disable import/prefer-default-export */

import {
  TOUR_CHANGED,
  TOUR_DATES_CHANGED
} from '../constants/editTourConstants';

const axios = require('axios').default;
import { toast } from 'react-toastify';

import $ from 'jquery';
require('datatables.net-bs4');

export const tourChanged = (tour) => ({
  type: TOUR_CHANGED,
  tour
});

export const tourDatesChanged = (tourDates) => ({
  type: TOUR_DATES_CHANGED,
  tourDates
});
